<template>
  <div style="position: relative" absolute>
    <v-responsive
      class="text-center fill-height"
    >
      <v-responsive height="100vh" id="page1_home">
        <Page1/>
      </v-responsive>
      <v-responsive height="100vh" id="page2_home">
        <Page2/>
      </v-responsive>
      <v-responsive height="100vh" id="page3_home">
        <Page3/>
      </v-responsive>
      <v-responsive height="100vh" id="page4_home">
        <Page4/>
      </v-responsive>
    </v-responsive>
    <v-btn v-if="$vuetify.breakpoint.smAndDown" fab fixed bottom depressed large outlined
           style="margin-bottom: 7px; margin-right: 3px;"
           color="transparent" right>
      <img v-if="target===4"
           :src="require('@/assets/arrow_up.png')"
           height="50"
           style="cursor:pointer !important;"
           contain
           @click="scrollUp()"
      />
      <img v-else
           :src="require('@/assets/arrow_down.png')"
           height="50"
           style="cursor:pointer !important;"
           contain
           @click="scrollDown()"
      />
    </v-btn>
    <v-btn v-else fab fixed bottom depressed large outlined style="margin-bottom: 150px; margin-right: 100px;"
           color="transparent" right>
      <img v-if="target===4"
           :src="require('@/assets/arrow_up.png')"
           height="100"
           style="cursor:pointer !important;"
           contain
           @click="scrollUp()"
      />
      <img v-else
           :src="require('@/assets/arrow_down.png')"
           height="100"
           style="cursor:pointer !important;"
           contain
           @click="scrollDown()"
      />
    </v-btn>
  </div>
</template>

<script>
  import { easeInOutCubic } from 'vuetify/lib/services/goto/easing-patterns';
  import Page1 from '@/components/home/Page1_home';
  import Page2 from '@/components/home/Page2_home';
  import Page3 from '@/components/home/Page3_home';
  import Page4 from '@/components/home/Page4_home';

  export default {
    components: {
      Page1,
      Page2,
      Page3,
      Page4
    },
    data: () => ({
      isActive: false,
      isActive1: false,
      isScroll: true,
      target: 1,
      options: {
        duration: 300,
        offset: 0,
        easing: easeInOutCubic,
      }
    }),
    created() {
      window.addEventListener('DOMMouseScroll', this.handleMouseWheelDOM);  // Mozilla Firefox
      window.addEventListener('mousewheel', this.handleMouseWheel, { passive: false }); // Other browsers

      window.addEventListener('touchstart', this.touchStart, { passive: false }); // mobile devices
      window.addEventListener('touchmove', this.touchMove, { passive: false }); // mobile devices
    },
    destroyed() {
      window.removeEventListener('mousewheel', this.handleMouseWheel, { passive: false });  // Other browsers
      window.removeEventListener('DOMMouseScroll', this.handleMouseWheelDOM); // Mozilla Firefox

      window.removeEventListener('touchstart', this.touchStart); // mobile devices
      window.removeEventListener('touchmove', this.touchMove); // mobile devices
    },
    methods: {
      scrollDown() {
        switch (this.target) {
          case 1:
            this.target = 2
            break;
          case 2:
            this.target = 3
            break;
          case 3:
            this.target = 4
            break;
        }
        document.querySelector('#' + "page" + this.target + '_home').scrollIntoView({ behavior: "smooth" });
      },
      scrollUp() {
        this.target = 1
        document.querySelector('#' + "page" + this.target + '_home').scrollIntoView({ behavior: "smooth" });
      },
      handleMouseWheel: function (e) {

        if (e.wheelDelta < 30 && !this.inMove) {
          this.moveUp();
        } else if (e.wheelDelta > 30 && !this.inMove) {
          this.moveDown();
        }

        e.preventDefault();
        return false;
      },
      handleMouseWheelDOM: function (e) {

        if (e.detail > 0 && !this.inMove) {
          this.moveUp();
        } else if (e.detail < 0 && !this.inMove) {
          this.moveDown();
        }

        return false;
      },
      touchStart(e) {
        this.touchStartY = e.touches[0].clientY;
        // e.preventDefault();
        // return false;
      },
      touchMove(e) {
        e.preventDefault();
        const currentY = e.touches[0].clientY;
        if (this.touchStartY < currentY) {
          this.moveDown();
        } else {
          this.moveUp();
        }
        this.touchStartY = 0;
        return false;
      },
      moveDown() {
        this.scrollToSection(false);
      },
      moveUp() {
        this.scrollToSection(true);
      },
      scrollToSection(isUp) {
        if (this.isScroll) {
          if (isUp) {
            if (this.target === 4) {
              // return
            } else {
              this.target = this.target + 1
            }
          } else {
            if (this.target === 1) {
              // return
            } else {
              this.target = this.target - 1
            }
          }
          this.isScroll = false;
          document.querySelector('#' + 'page' + this.target + '_home').scrollIntoView({ behavior: "smooth" });
          setTimeout(() => {
            this.isScroll = true;
          }, 500);

        }
      },
    },
  };
</script>
